import { get } from 'lodash';

export const ApiErrorLookup = {
  UNKNOWN: 'An unknown error occurred.',
  UNAUTHORIZED: 'The user session is no authorized.',
  AUTH_USER_NOT_FOUND: 'Username not found.'
};

export const getErrorName = error =>
  get(error, 'response.data.error_code', ApiErrorLookup.UNKNOWN);

export const getErrorDetails = (contextMessage: string, error: Error) =>
  `${contextMessage} ${ApiErrorLookup[getErrorName(error)] || ''}`;
